// Copyright (c) Docugami, Inc. All rights reserved.

import { ExplorerInfoText, ExplorerInfoTextBold } from "./ExplorerStyles"

interface DocumentCountInfoProps {
    count: number;
    countName: string;
    additionalText?: string;
}

export const DocumentCountInfo = (props: DocumentCountInfoProps): JSX.Element => {
    return (
        <div data-testid="explorer-document-count">
            <ExplorerInfoTextBold>{props.count}</ExplorerInfoTextBold>
            <ExplorerInfoText> {(props.countName ?? 'Document') + (props.count !== 1 ? 's' : '')}</ExplorerInfoText>
            <ExplorerInfoText>{props.additionalText}</ExplorerInfoText>
        </div>
    );
}
